import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import utilsUsers from "../Connections/_Utils/utilsUsers";
import {
    AddCircleOutline, AlignHorizontalLeftRounded, ArrowCircleRightSharp,
    ArrowCircleUp, ContactlessOutlined, HighlightOff, RemoveCircleOutline
} from "@mui/icons-material";

import styles from './GetSpecialRemarks.module.css';

import pageStylePops from './pageStylePops.module.css';


import utilsOrders from "../Connections/_Utils/utilsOrders";

import Scroll from 'react-scroll';

import { UserContext } from "../Contexts/User_Context";
import { Checkbox } from "@mui/material";
import { MasterContext } from "../Contexts/Master_Context";
import { MobiOrNotContext } from "../Contexts/MobiOrNot_Context";
import { TheOrderContext } from "../Contexts/TheOrder_Context";

var scroller = Scroll.scroller;

const GetSpecialRemarks = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const { theOrder, setTheOrder, addToTheOrder, updateTheOrd } = useContext(TheOrderContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);

    const [remarks, setRemarks] = useState(props.inOrder.orderRemarks || "");


    const navigate = useNavigate();

    useEffect(() => {

    }, [])



    const setTheRemarks = (remarksAsks) => {
        setRemarks(remarksAsks);
    }

    const continueIt = () => {
        props.theFunction(remarks);
    }

    return (
        <div className={"loginPage spaceMargeTop_10 "}>

            <div className={`${pageStylePops.secondHead}  regularPoint`}>
                <div className={"inColorgoldLine"}>לפני שנסיים, אם יש עוד משהו שהיית רוצה לציין, זה המקום</div>
                <div className={`${styles.usrDetLong} details spaceMargeTop_10`} >
                    <textarea className={`${styles.txtArea}`} value={remarks}
                        placeholder={"בקשות מיוחדות"} onChange={(e) => setTheRemarks(e.target.value)}></textarea>
                </div>
            </div>
            <div className={pageStylePops.contWrap}>
                <div className={pageStylePops.btnGo}>
                    <button className={`${pageStylePops.contactGo} pointing`} value="המשך"
                        onClick={() => continueIt()} >המשך</button>
                </div>
            </div>
        </div>


    )

}

export default GetSpecialRemarks